// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { HistoryType } from '@shared/utils/History/HistoryType';
import { ChartDataType, ChartHistoryType } from '@front/chart/Utils/ChartConstants';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { Periods } from '@shared/utils/History/TFInfo';
// TODO. Refactor. UGLY.
export class HistoricalData {
    constructor(holder, customInstrument, customCashItem) {
        var _a;
        this._holder = holder;
        this.cashItem = customCashItem || holder.FParent;
        this.Instrument = customInstrument || ((_a = holder.MainChart) === null || _a === void 0 ? void 0 : _a.Instrument());
        // Taken from HistoricalData.cs Apply() method.
        this.GetCashItemCount = this.cashItem === holder.FParent ? this.BarsCountParent : this.BarsCountAny;
    }
    get Indicator() {
        return this._holder;
    }
    get Count() {
        return this.GetCashItemCount(this.cashItem);
    }
    get HistoryCount() {
        return this.cashItem ? this.cashItem.Count() : 0;
    }
    get Period() {
        return this.cashItem.FPeriod;
    }
    // TODO. Refactor. UGLY.
    get Account() {
        return this._holder.MainChart.model.GetAccount();
    }
    get DataType() {
        return this.cashItem.HistoryType;
    }
    // TODO. Refactor. UGLY.
    get UseDefaultInstrumentHistoryType() {
        return this._holder.MainChart.ChartHistoryType() === ChartHistoryType.Default;
    }
    // TODO. Refactor. UGLY.
    get FirstBarOpenTime() {
        const time = this.cashItem.GetOpenTime(0);
        return new Date(time || 0);
    }
    get LastBarCloseTime() {
        const barsCount = this.cashItem.FNonEmptyCashArrayCount;
        const time = this.cashItem.GetCloseTime(barsCount - 1);
        return new Date(time || 0);
    }
    getToTimeForRequest() {
        const lastBarTime = this.LastBarCloseTime;
        if (this.cashItem.isRealTimeBuilding) {
            lastBarTime.setMinutes(lastBarTime.getMinutes() + 10);
        }
        return lastBarTime;
    }
    Time(offset = 0) {
        const count = this.GetCashItemCount(this.cashItem);
        if (!count) {
            throw new Error('Cannot get the value from the empty data');
        }
        const time = this.cashItem.GetOpenTime(count - 1 - offset);
        return new Date(time || 0);
    }
    BarsCountParent(ci) {
        return this._holder.FCount;
    }
    BarsCountAny(ci) {
        return ci ? ci.Count() : 0;
    }
    getPriceByType(priceType, offset = 0) {
        const ci = this.cashItem;
        const count = this.GetCashItemCount(ci);
        if (offset < 0 || offset >= count) {
            throw new Error('offset ' + offset + ' should be non-negative and smaller than Count');
        }
        const correctPriceType = this.getCorrectPriceType(priceType);
        return ci.GetByType(count - 1 - offset, correctPriceType);
    }
    Volume(offset) {
        offset = offset || 0;
        const ci = this.cashItem;
        const count = this.GetCashItemCount(ci);
        if (!count) {
            throw new Error('Cannot get the value from the empty data');
        }
        if (offset < 0 || offset >= count) {
            throw new Error('offset ' + offset + ' should be non-negative and smaller than Count');
        }
        return ci.GetVolume(count - 1 - offset);
    }
    static HistoricalDataFactory(holder, instrument, cashItem) {
        // #65320 для агрегаций мы должны использовать BarData
        if (cashItem.Period === 0 && cashItem.ChartDataType === ChartDataType.Default) {
            if (cashItem.HistoryType === HistoryType.QUOTE_TRADES) {
                return new TradeData(holder, instrument, cashItem);
            }
            else {
                return new TickData(holder, instrument, cashItem);
            }
        }
        else {
            return new BarData(holder, instrument, cashItem);
        }
    }
    FindInterval(par0, par1, par2) {
        if (par0 !== undefined && par1 !== undefined && par2 !== undefined) {
            return this.cashItem.FindInterval(par0, par1, par2);
        }
        if (par0 !== undefined && par1 === undefined && par2 === undefined) {
            return this.cashItem.FindIntervalByTime(par0);
        }
    }
    getCorrectPriceType(priceType) {
        const ci = this.cashItem;
        if (ci.Period === Periods.TIC && ci.ChartDataType === ChartDataType.Default) {
            return PriceType.Close;
        }
        return priceType;
    }
}
// #region TradeData
export class TradeData extends HistoricalData {
    constructor(holder, instrument, cashItem) {
        super(holder, instrument, cashItem);
        throw new Error('Not implemented');
    }
}
// #endregion TradeData
// #region TickData
export class TickData extends HistoricalData {
    constructor(holder, instrument, cashItem) {
        super(holder, instrument, cashItem);
        throw new Error('Not implemented');
    }
}
// #endregion TickData
// #region BarData
export class BarData extends HistoricalData {
}
// #endregion BarData
